import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import style from './style.module.css';

import Card from '../../components/Card/Card';

import { getLanguageArray, getUserFirstName, 
  Language, getToken, getLabel, welcomeLabel,
  organizationsLabel, viewAllLabel,
  urlOrganizations,
  usersLabel,
  reportsLabel,
  urlReports,
  systemLanguage,
  getOrganizationsCount,
  getUserCount
} from '../../utils/constants';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faBuilding, faUsers } from '@fortawesome/free-solid-svg-icons';

const DashboardView: React.FC = () => {
    const activeToken = getToken();
    const navigate = useNavigate();

    const [loading, isLoading] = useState(true);
    const [sessionLang, setSessionLang] = useState<Language>(getLanguageArray());

    useEffect(() => {
        const handler = (e: StorageEvent) => {
            if (e.key === systemLanguage && e.newValue) {
                setSessionLang(JSON.parse(e.newValue));
            }
        };
        window.addEventListener("storage", handler);
        return () => window.removeEventListener("storage", handler);
    }, []);

    const lang = sessionLang.short || 'EN';

    return (
       <>
       <div className={style.dashboard}>
            <div className={style.profile}>
                <div className={`${style.sectionTitle} ${style.textContainerGrad}`}>
                    {getLabel(welcomeLabel, sessionLang)}, {getUserFirstName()}
                </div>
                <div className={style.quickLinks}>
                    <div className={style.four}>
                        <Card
                            type="usage"
                            usageData={{
                                title: getLabel(organizationsLabel, sessionLang),
                                title2: "",
                                object: `${getOrganizationsCount()}`,
                                details: `Active Organizations`,
                                details2: "",
                                percentage: 0
                            }}
                        />
                    </div>
                    <div className={style.four}>
                        <Card
                            type="usage"
                            usageData={{
                                title: getLabel(usersLabel, sessionLang),
                                title2: "",
                                object: `${getUserCount()}`,
                                details: `Active Users`,
                                details2: "",
                                percentage: 0
                            }}
                        />
                    </div>
                    <div className={style.four}>
                        <Card
                            type="icon"
                            iconData={{
                                icon: <FontAwesomeIcon icon={faBuilding} />,
                                color: "blue",
                                title: getLabel(organizationsLabel, sessionLang),
                                link: getLabel(viewAllLabel, sessionLang),
                                href: urlOrganizations
                            }}
                        />
                    </div>
                    <div className={style.four}>
                        <Card
                            type="icon"
                            iconData={{
                                icon: <FontAwesomeIcon icon={faUsers} />,
                                color: "red",
                                title: getLabel(reportsLabel, sessionLang),
                                link: getLabel(viewAllLabel, sessionLang),
                                href: urlReports
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
       </>
    );
};

export default DashboardView


